import firebaseConfig from '../../firebase-applet-config.json';

/**
 * AzuraOS App & Authentication Configuration Utility
 * Standardizes application title, branding metadata, project identifiers, and auth flow settings.
 */
export const APP_CONFIG = {
  appName: 'AzuraOS — Founder Operating System',
  shortName: 'AzuraOS',
  tagline: 'Sovereign control over every income stream',
  authTitle: 'AzuraOS — Founder Operating System',
  displayProjectId: 'AzuraOS — Founder Operating System',
  rawProjectId: firebaseConfig.projectId || 'intelligent-cathode-118qq',
  authDomain: 'AzuraOS Auth Portal',
  billingBrand: 'AzuraOS Billing',
  supportEmail: 'support@azuraos.app',
  trialDays: 7,
  supportedCurrencies: ['ZAR', 'USD', 'EUR', 'GBP', 'AUD', 'CAD', 'SGD', 'INR'],
  version: '2026.3.1-Sovereign'
};

/**
 * Returns the primary display app name.
 */
export function getDisplayAppName(): string {
  return APP_CONFIG.appName;
}

/**
 * Returns the authentication flow title.
 */
export function getAuthTitle(): string {
  return APP_CONFIG.authTitle;
}

/**
 * Maps raw technical project IDs (e.g. 'intelligent-cathode-118qq') to user-facing branding.
 * @param rawProjectId Optional technical project ID string
 * @param includeTechnicalCode If true, appends the technical project code in brackets for audit purposes
 */
export function getDisplayProjectId(rawProjectId?: string, includeTechnicalCode = false): string {
  const code = rawProjectId || firebaseConfig.projectId || APP_CONFIG.rawProjectId;
  if (includeTechnicalCode) {
    return `${APP_CONFIG.appName} (${code})`;
  }
  return APP_CONFIG.appName;
}

/**
 * Returns formatted brand string for OAuth popups and Firebase Sign-In titles.
 */
export function getOAuthBrandTitle(): string {
  return `${APP_CONFIG.shortName} Authorized Workspace`;
}
